export const environment = {
  production: false,
  apiUrl: 'https://live-post-blank.softsale.kz',
  liveWebsocketPath: '/ws/lives',
};
